import { render, staticRenderFns } from "./PopupNotificacaoVer.vue?vue&type=template&id=3fdf513e&"
import script from "./PopupNotificacaoVer.vue?vue&type=script&lang=js&"
export * from "./PopupNotificacaoVer.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotificacaoVer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports